// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"SimpleCheckbox_checkbox__GthyN","checkmark":"SimpleCheckbox_checkmark__LTCvI","label":"SimpleCheckbox_label__HIZBC","selected":"SimpleCheckbox_selected__p0C_4"};